import {jzbReqAcc} from '@/models/jzbModel'
const state = {
  jzb_enable: null
}

const mutations = {
  JZB_ENABLE_CHANGE: (state, enable) => {
    state.jzb_enable = enable
  }

}

const actions = {
  jzb_enable_change ({ commit }) {
    jzbReqAcc({
      'shopId': parseInt(localStorage.getItem('shop_id')),
      'objectType': 2
    })
      .then(res => {
        if (res.code === 200) {
          let data = res.data[0]
          if (data.enabled === 0) {
            commit('JZB_ENABLE_CHANGE', false)
            localStorage.setItem('jzb_enable', 0)
          } else if (data.enabled === 1) {
            commit('JZB_ENABLE_CHANGE', true)
            localStorage.setItem('jzb_enable', 1)
          } else {
            localStorage.setItem('jzb_enable', 0)
          }
          // return Promise(data.enabled)
        } else {
          localStorage.setItem('jzb_enable', 0)
        }
      })
      .catch(error => {
        localStorage.setItem('jzb_enable', 0)
        console.log(error)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/jzb.js